<template>
    <div class="common-flex-center-between toolbar-container" :ref="refName">
        <div class="toolbar-search-box common-all-margin">
            <div>
                <slot></slot>
            </div>
        </div>
        <el-button-group class="common-all-margin">
            <el-button v-if="importStatus" type="success"   @click="onImport">导入</el-button>
           <!-- <el-button v-if="exportStatus" type="primary" @click="onExport">导出</el-button> -->
            <el-button v-if="addStatus" type="primary" @click="onAddClick">{{addText}}</el-button>
            <el-button v-if="deleteStatus" @click="onDeleteClick">{{deleteText}}</el-button>
            <template v-if="extendStatus">
                <el-button :icon="button.icon"  @click="button.event" :type="button.type" :key="index" v-for="(button, index) in extendButtons">{{button.title}}</el-button>
            </template>
        </el-button-group>
    </div>
</template>

<script>

export default {
    name: 'TableTopBar',
    watch: {
        popoverProps: function (nv, ov) {
            if (nv !== ov) {
                this.popoverProps = this.Tools.get().ObjectTools.merge(nv, {
                    placement: 'bottom-start',
                    width: '700',
                    trigger: 'click',
                    buttonText: '点击搜索'
                })
            }
        }
    },
    data() {
        return {
            searchData: '',
            refName: '',
            height: 0,
            list: [],
            advancedSearch: false
        }
    },
    computed: {
        addStatus() {
            return this.buttonStatus & this.ButtonEnums.BarButton.addButton
        },
        deleteStatus() {
            return this.buttonStatus & this.ButtonEnums.BarButton.deleteButton
        },
        importStatus () {
            return this.buttonStatus & this.ButtonEnums.BarButton.importButton
        },
        exportStatus () {
            return this.buttonStatus & this.ButtonEnums.BarButton.exportButton
        },
        extendStatus () {
            return this.buttonStatus & this.ButtonEnums.BarButton.extendButton
        }
    },
    props: {
        buttonStatus: {
            type: Number,
            default() {
                return this.ButtonEnums.BarButton.addButton | this.ButtonEnums.BarButton.searchButton
            }
        },
        addText: {
            type: String,
            default: '新增'
        },
        deleteText: {
            type: String,
            default: '删除'
        },
        importText: {
            type: String,
            default: '导入'
        },
        exportText: {
            type: String,
            default: '导出'
        },
        popoverProps: {
            type: Object,
            default() {
                return {
                    placement: 'bottom-start',
                    width: '700',
                    trigger: 'click',
                    buttonText: '点击搜索'
                }
            }
        },
        extendButtons: {
            type: Array,
            default() {
                /*{type: '', icon: '', title: '', event: funciont (){}}*/
                return  []
            }
        }
    },
    methods: {
        onAddClick() {
            this.$emit('add-click')
        },
        onDeleteClick() {
            this.$emit('delete-all-select-click')
        },
        onSearchClick() {
            this.$emit('search-click')
        },
        onImport(){ //导入
            this.$emit('import')
        },
        onExport(){ //导出
            this.$emit('export')
        }
    },
    mounted() {
        /*const $this = this
        let oldHeight = $this.height
        $this.refName = 'ttb_' + new Date().getTime()
        setInterval(() => {
            try {
                let height = $this.$refs[$this.refName].clientHeight
                if (oldHeight !== height) {
                    $this.height = height
                    $this.$emit('height-change', $this.height, oldHeight)
                    oldHeight = $this.height
                }
            } catch (e) {
            }
        }, 100)*/
    }
}
</script>

<style lang="scss" scoped>
.toolbar-search-box {
    width: 40%;
    float: right;
}

.toolbar-container {
    height: 60px;
    box-sizing: border-box;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/Toolbar/TableTopBar.vue"
}
</vue-filename-injector>
